export class MissingCompanyTaxIdError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, MissingCompanyTaxIdError.prototype);
  }
}
